import { render, staticRenderFns } from "./ContenuAdmin.vue?vue&type=template&id=045c9c4a"
import script from "./ContenuAdmin.vue?vue&type=script&lang=js"
export * from "./ContenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./ContenuAdmin.vue?vue&type=style&index=0&id=045c9c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports